import { PatientServiceItem, PatientServiceItemType } from '@uplift/api';
import { AppointmentServiceDetails } from './AppointmentServiceDetails.component';
import { MedicalNoteServiceDetails } from './MedicalNoteServiceDetails.component';
import { Box, TableCell, TableRow } from '@mui/material';


import { makeStyles } from 'tss-react/mui';


const useStyles = makeStyles()(theme => ({
  cell: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.grey[50],
  }
}));


export const TableServiceDetailsComponent = ({ row }: { row: PatientServiceItem }) => {
  const { classes } = useStyles();

  if (row.serviceType === PatientServiceItemType.appointment) {
    return (
      <TableRow>
        <TableCell colSpan={5} className={classes.cell}>
          <AppointmentServiceDetails row={row} />
        </TableCell>
      </TableRow>
    );
  }

  if (row.serviceType === PatientServiceItemType.medicalNote) {
    return (
      <TableRow>
        <TableCell colSpan={5} className={classes.cell} style={{ verticalAlign: 'text-top' }}>
          <MedicalNoteServiceDetails row={row} />
        </TableCell>
      </TableRow>
    );
  }

  return null;
};


export const ModalServiceDetailsComponent = ({ row }: { row: PatientServiceItem }) => {
  if (row.serviceType === PatientServiceItemType.appointment) {
    return (
      <Box bgcolor="grey.50" flex={1}>
        <AppointmentServiceDetails row={row} />
      </Box>
    );
  }

  if (row.serviceType === PatientServiceItemType.medicalNote) {
    return (
      <Box bgcolor="grey.50" flex={1}>
        <MedicalNoteServiceDetails row={row} />
      </Box>
    );
  }

  return null;
};
